import { createContext, useContext } from "react";

/**
 * Chat Context
 * Manages global chat state and ChatGPT interactions
 */
export const ChatContext = createContext({
  // Chat messages
  messages: [],
  addMessage: () => {},
  clearMessages: () => {},

  // Chat state
  isTyping: false,
  setIsTyping: () => {},

  // ChatGPT availability
  isAvailable: false,
  isLoading: true,
  error: null,

  // Send message to ChatGPT
  sendMessage: async () => {},

  // Conversation management
  conversationId: null,
  startNewConversation: () => {},

  // Chat widget state
  isOpen: false,
  openChat: () => {},
  closeChat: () => {},
  toggleChat: () => {},
});

/**
 * Custom hook to use Chat Context
 * @returns {Object} Chat context value
 *
 * @example
 * const { messages, sendMessage, isTyping } = useChatContext();
 */
export const useChatContext = () => {
  const context = useContext(ChatContext);

  if (!context) {
    throw new Error("useChatContext must be used within ChatProvider");
  }

  return context;
};
